import src from "IMAGE";
export default { src, width: 2000, height: 752, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARklEQVR42jXK2w7AIAgDUP//YxWdyjXpBskeTgJtG62FZ2+MMdB7x5wT916YWWn7KzMgopI/MxcRQcuVuyMiyn+rKs45eAHqgF0iCHxBTwAAAABJRU5ErkJggg==", blurWidth: 8, blurHeight: 3 }
